import { render, staticRenderFns } from "./ReactionFace.vue?vue&type=template&id=295bbca3&scoped=true&lang=pug&"
import script from "./ReactionFace.vue?vue&type=script&lang=ts&"
export * from "./ReactionFace.vue?vue&type=script&lang=ts&"
import style0 from "./ReactionFace.vue?vue&type=style&index=0&id=295bbca3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bbca3",
  null
  
)

export default component.exports